import {Component, Input, Output, EventEmitter, OnInit, AfterViewInit} from '@angular/core';
import {ChoiceSelection, Resolution} from '../../../shared/model/poll.model';
import * as url from 'url';

@Component({
  selector: 'app-poll-resolution-choices-list',
  templateUrl: './poll-resolution-choices-list.component.html',
  styleUrls: ['./poll-resolution-choices-list.component.less'],
})
export class PollResolutionChoicesListComponent implements AfterViewInit {

  @Input() selectedResolution: Resolution;
  @Input() isMobile: boolean;
  @Output() selected = new EventEmitter<ChoiceSelection>();
  @Input() initialVotes: number[];
  @Input() liveActiveResolution: number;

  select(event: ChoiceSelection) {
    event.roundIndex = this.liveActiveResolution;
    this.selected.emit(event);
  }

  replaceURLs(message: string) {
    if (!message) { return; }
    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return message.replace(urlRegex, (url) => {
      let hyperlink = url;
      if (!hyperlink.match('^https?:\/\/')) {
        hyperlink = 'http://' + hyperlink;
      }
      return hyperlink;
    });
  }

  ngAfterViewInit(): void {
    if (this.initialVotes != null && this.initialVotes.length > 0) {
      const votedIndex = this.initialVotes[0];
      const voteBox = document.getElementById(`checkbox-${votedIndex}`) as HTMLInputElement;
      if (voteBox != null) {
        voteBox.checked = true;
      }
    }
  }
}
